
export default {
  data() {
    return {
      mostrarColumnaAutor: false,
    }
  },
  watch: {
    mostrarColumnaAutor(newValue, oldValue) {
      this.actualizarInfo()
    }
  },
  methods: {
    toggleMostrarAutor() {
      this.mostrarColumnaAutor = !this.mostrarColumnaAutor;
    },
  },
  computed: {
  },
  created() {
  }
}
